<template>
  <div class="clear-dates">
    <base-button class="tiny icon minimal" @click="$emit('click')">
      <img src="@/assets/images/refresh.svg" class="icon" />
      <translate>Clear dates</translate>
    </base-button>
  </div>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  emits: ['click'],
})
class DatesWizardBodyClearButton extends Vue {}

export default toNative(DatesWizardBodyClearButton)
</script>
<style scoped>
.clear-dates {
  align-items: flex-start;
  display: inline-flex;
  justify-content: center;
  margin: 4em 0 0 0;
  position: absolute;
}

.clear-dates button {
  font-size: var(--body);
  display: inline-flex;
  align-items: center;
  gap: 0.35em;
}

button .icon {
  height: 1em;
  opacity: 0.4;
  margin: -0.1em 0 0 0;
}
</style>
